import { useEffect, useMemo, useState } from 'react'
import Spinner from '../../components/Spinners/Spinner'
import { fetchImmHistory } from '../../services/onboarding'
import { formatCurrency } from '../../config/resources/utils'
import * as S from '../DashboardUtm/DashboardUtmYear.styles'

const formatImmPeriod = (value) => {
  if (!value) return 'Vigente'
  const raw = String(value).slice(0, 10)
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month] = raw.split('-').map(Number)
    const date = new Date(Date.UTC(year, month - 1, 1))
    const label = new Intl.DateTimeFormat('es-CL', {
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(date)
    return label.charAt(0).toUpperCase() + label.slice(1)
  }
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'Vigente'
  const label = new Intl.DateTimeFormat('es-CL', {
    month: 'long',
    year: 'numeric',
  }).format(date)
  return label.charAt(0).toUpperCase() + label.slice(1)
}

const DashboardImmHistory = () => {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const currentYear = useMemo(() => new Date().getFullYear(), [])

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      setLoading(true)
      setError(null)
      try {
        const history = await fetchImmHistory()
        if (!cancelled) setRows(history)
      } catch (err) {
        if (!cancelled) {
          setError(err?.message || 'No pudimos cargar el IMM.')
          setRows([])
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [])

  const yearRows = useMemo(
    () =>
      rows.filter((row) => {
        if (!row.effectiveFrom) return false
        const year = Number(String(row.effectiveFrom).slice(0, 4))
        return year === currentYear
      }),
    [rows, currentYear]
  )

  const cards = yearRows.length > 0 ? yearRows : rows.slice(0, 6)

  return (
    <S.Panel>
      {loading && <Spinner />}
      {!loading && error && (
        <S.ErrorText>No pudimos cargar los valores del IMM.</S.ErrorText>
      )}

      {!loading && !error && cards.length > 0 && (
        <S.MonthGrid>
          {cards.map((row, index) => {
            const isCurrent = index === 0
            return (
              <S.MonthCard key={row.id} $current={isCurrent} $empty={false}>
                <S.MonthName $current={isCurrent}>
                  {formatImmPeriod(row.effectiveFrom)}
                </S.MonthName>
                <S.MonthValue>{formatCurrency(row.value)}</S.MonthValue>
                {row.source && <S.MonthSource>{row.source}</S.MonthSource>}
                {isCurrent && <S.MonthTag>Vigente</S.MonthTag>}
              </S.MonthCard>
            )
          })}
        </S.MonthGrid>
      )}

      {!loading && !error && cards.length === 0 && (
        <S.EmptyState>
          <S.EmptyHint>
            Aún no hay valores del Ingreso Mínimo Mensual cargados.
          </S.EmptyHint>
        </S.EmptyState>
      )}
    </S.Panel>
  )
}

export default DashboardImmHistory
